import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

const ManageSignaturesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 22" // keep your original viewBox
    >
      <defs>
        <linearGradient
          id="manage-signatures-gradient"
          x1="12"
          y1="0"
          x2="12"
          y2="21.0822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E2339" />
          <stop offset="1" stopColor="#620000" />
        </linearGradient>
      </defs>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.055 3.48649e-05C16.2933 -0.0019183 16.4984 0.0781616 16.6761 0.248087L19.268 2.72861C19.436 2.88877 19.518 3.10167 19.5219 3.33605C19.5258 3.57434 19.4555 3.79114 19.2914 3.95716L17.9125 5.39274L14.0823 1.69343L15.4476 0.271525C15.6156 0.0976933 15.8187 0.0039412 16.055 3.48649e-05ZM3.9239 13.3382C4.39266 13.1937 4.88681 13.4574 5.03135 13.9242C5.17588 14.3929 4.91221 14.8871 4.4454 15.0316C3.08209 15.4496 2.168 16.2582 1.86526 17.018C1.78518 17.2211 1.75784 17.4067 1.78909 17.559C1.81252 17.6743 1.88284 17.7797 1.99808 17.8637C2.49613 18.227 3.56842 18.3208 5.36925 17.8833C6.43568 17.6235 7.57828 17.2719 8.59002 16.9594C9.62325 16.641 10.5256 16.3617 11.1526 16.2445C12.3089 16.0297 13.4632 15.8832 14.3948 15.9301C15.6175 15.9906 16.5355 16.3832 16.85 17.3227C17.0531 17.9301 16.9965 18.4575 16.9457 18.9302C16.9281 19.1001 16.9105 19.2583 16.9183 19.3618C16.9183 19.3657 17.1039 19.352 17.9984 19.2817C19.0336 19.1997 20.1059 18.7915 21.1645 18.3872C21.7075 18.1801 22.2466 17.9751 22.8579 17.7875C23.3267 17.645 23.8208 17.9106 23.9615 18.3774C24.104 18.8462 23.8384 19.3403 23.3716 19.4809C22.897 19.6255 22.3481 19.8364 21.7974 20.0454C20.6176 20.4946 19.4262 20.9497 18.1371 21.0513C15.7796 21.2368 15.2328 20.5708 15.1488 19.4985C15.1292 19.2466 15.1546 19.0024 15.182 18.7407C15.2132 18.4477 15.2484 18.1196 15.1683 17.8833C15.1331 17.7778 14.7991 17.7231 14.3109 17.6997C13.5315 17.6606 12.51 17.7934 11.4709 17.9868C10.9534 18.0825 10.094 18.3481 9.10957 18.6528C8.08025 18.9712 6.91811 19.3286 5.78527 19.604C3.41412 20.1802 1.83792 19.936 0.955084 19.2915C0.458979 18.9302 0.16405 18.4575 0.0507663 17.9243C-0.0547049 17.4282 0.00584339 16.893 0.216786 16.3617C0.697265 15.1625 2.01956 13.9203 3.9239 13.3382ZM8.06267 9.46314L10.4123 11.723L7.53922 12.4945C7.4357 12.514 7.39468 12.473 7.41226 12.3773L8.06267 9.46314ZM12.8675 2.95127L16.6937 6.6369L11.467 12.1546L6.78334 13.4105C6.61537 13.4437 6.54896 13.3773 6.57631 13.2191L7.63688 8.47093L12.8675 2.95127Z"
        fill="url(#manage-signatures-gradient)"
      />
    </SvgIcon>
  );
};

export default ManageSignaturesIcon;
